import React, { useState } from "react";
import omnifood from "./omnifood.png";
import bankist from "./bankist.png";
import ilearned from "./ilearned.png";
import moviesinfo from "./moviesinfo.png";
import todo from "./todo.png";
import guess from "./guess.png";
import myanimelist from "./myanimelist.png";
import "./Projects.css";
import "./style.css";

const Projects = (props) => {
  const [visible, setVisible] = useState(3);
  // const [load, setLoad] = useState(true)
  const projects = [
    {
      id: 1,
      title: "Movies Info",
      description:
        "MoviesApp is a website designed using ReactJS to get information on movies. It features search functionality, React Hooks, React Router, and Pagination, demonstrating technical skills in ReactJS, API integration, UX design, and search functionality.",
      languages: "HTML CSS JAVASCRIPT REACTJS",
      image: moviesinfo,
      link: "https://mymoviesinfoapp.netlify.app/",
    },

    {
      id: 2,
      title: "Today I Learned",
      description:
        " Today I Learned is a ReactJS website that allows users to share and vote on facts. The website uses a Supabase backend to manage user input and voting data. It also features a voting system that allows users to determine the validity of shared facts.",
      languages: "HTML CSS JAVASCRIPT REACTJS",
      image: ilearned,
      link: "https://ilearnedfacts.netlify.app/",
    },

    {
      id: 3,
      title: "My-AnimeList",
      description:
        "MyAnimeList is a responsive website designed using ReactJS that provides information about anime. The website integrates the Jikan API and uses React Hooks, React Router, and Framer-Motion to enhance the user experience.",
      languages: "HTML CSS JAVASCRIPT REACTJS",
      image: myanimelist,
      link: "https://myanimedblist.netlify.app/",
    },

    {
      id: 4,
      title: "Omni-Food Website",
      description:
        "Omni-Food is a responsive food ordering website designed using HTML,CSS and JAVASCRIPT with minimalistic and interactive user interface",
      languages: "HTML CSS JAVASCRIPT",
      image: omnifood,
      link: "https://omnifoodies.netlify.app/",
    },

    {
      id: 5,
      title: "Bankist Website",
      description:
        "Bankist Website is a marketting website designed using HTML,CSS and JAVASCRIPT . The website has a cool user interface and animations using DOM MANIPULATION.",
      languages: "HTML CSS JAVASCRIPT",
      image: bankist,
      link: "https://bankistmark.netlify.app/",
    },

    {
      id: 6,
      title: "Todo List",
      description: "Todo list where you can add remove and filter your todos",
      languages: "HTML CSS Javascript",
      image: todo,
      link: "https://todoamaze.netlify.app/",
    },

    {
      id: 7,
      title: "Guess My Number",
      description: "This is a game where you have to guess the number.",
      languages: "HTML CSS Javascript",
      image: guess,
      link: "https://guessthe-num.netlify.app/",
    },
  ];

  //   {
  //   if(visible.length === visible[-1] ){
  //     setLoad(false)
  //   }
  // }

  function pageLoadHandler() {
    setVisible((prevValue) => prevValue + 3);
  }
  return (
    <section className={"projects " + props.className} id="projects">
      <div className="project-heading">
        <p className="heading-project">Some Projects I've Built</p>
      </div>
      <div className="grid">
        {projects &&
          projects.slice(0, visible).map((items) => {
            return (
              <a key={items.id} target="_blank" href={items.link}>
                <div key={items.id} className="project-container">
                  <div className="project-content">
                    <p className="project-title">{items.title}</p>
                    <p className="project-desc">{items.description}</p>
                    <p className="languages-used">{items.languages}</p>
                  </div>
                  <div className="project-image">
                    <img src={items.image} alt="omnifood" />
                  </div>
                </div>
              </a>
            );
          })}
      </div>
      <div className="button-load">
        {
          // load &&
          <button
            onClick={() => pageLoadHandler()}
            className="btn load btn-header"
          >
            Load More
          </button>
        }
      </div>
    </section>
  );
};

export default Projects;
